export enum PazaakCardGUITextures {
  CARD_BACK = 'lbl_cardback',
  CARD_HILIGHT = 'lbl_cardhilite',
  CARD_DRAWN = 'lbl_cardstand',
  CARD_POS = 'lbl_cardmpos',
  CARD_NEG = 'lbl_cardmneg',
  CARD_TWOSIDED_POS = 'lbl_cardrarem',
  CARD_TWOSIDED_NEG = 'lbl_cardraref',
}
